import React from 'react';
import { AlertTriangleIcon, CheckIcon, CrownIcon, LockIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['5 Tomos PDF (Principiante a Terapéutico)', '5 Bonos estratégicos', 'Acceso inmediato (5 min)', 'Garantía 7 días'];
const premiumFeatures = ['TODO el Combo Completo Stretching', '3 niveles Senior progresivos: Semilla, Raíz y Roble', 'Test de fragilidad funcional incluido', 'Protocolos específicos para 10 patologías senior', 'Sistema de precios y marketing Senior Gold', '1 alumno senior = 12-18 meses de ingresos'];
function PlanCard({
  premium = false,
  compact = false
}: {
  premium?: boolean;
  compact?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Combo Completo Stretching + Stretching Adultos Mayores' : 'Combo Completo Stretching';
  const subtitle = premium ? '5 Tomos + 5 Bonos + 50 páginas de Especialización Senior' : '5 Tomos + 5 Bonos';
  return <article className={`relative flex flex-col rounded-3xl p-6 ${premium ? 'bg-gradient-to-b from-primary to-[#052B44] text-white shadow-[0_25px_60px_rgba(7,59,92,.35)] ring-4 ring-gold/30 md:scale-[1.025]' : 'border border-sky-100 bg-white shadow-sm'} ${compact ? 'text-left' : 'md:p-8'}`} data-id="element-263">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-gold px-4 py-1.5 text-xs font-extrabold text-slate-900 shadow-lg" data-id="element-264">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-265" /> MÁS ELEGIDO
        </div>}

      <div className={premium ? 'mt-2' : ''} data-id="element-266">
        <div className="flex items-start gap-2" data-id="element-267">
          <span className="text-3xl" data-id="element-268">{premium ? '🏆' : '📘'}</span>
          <h3 className={`text-xl font-extrabold leading-tight ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-269">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-270">
          {subtitle}
        </p>
      </div>

      {!compact && <p className={`my-6 rounded-xl border p-4 text-sm leading-relaxed ${premium ? 'border-white/20 bg-white/10 text-sky-50' : 'border-sky-100 bg-sky-50/70 text-slate-600'}`} data-id="element-271">
          <b className={premium ? 'text-white' : 'text-slate-900'} data-id="element-272">
            Ideal para:
          </b>{' '}
          {premium ? 'Profesionales que quieren especializarse en el nicho más rentable de Argentina y asegurar 12-18 meses de ingresos por alumno.' : 'Profesionales que quieren tener todos los niveles de stretching resueltos de manera segura y profesional.'}
        </p>}

      <ul className="my-6 flex-1 space-y-2" data-id="element-273">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-274">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-gold' : 'text-teal'}`} data-id="element-275" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6" data-id="element-276">
        {premium && <span className="mb-3 inline-block rounded-full bg-gold px-3 py-1 text-xs font-extrabold text-slate-900" data-id="element-277">
            AHORRÁS $47.000
          </span>}
        <p className={`text-sm font-bold line-through ${premium ? 'text-sky-200' : 'text-slate-400'}`} data-id="element-278">
          Antes: {premium ? '$75.000' : '$60.000'}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-279">
          Hoy
        </p>
        <p className={`text-4xl font-extrabold ${premium ? 'text-white md:text-5xl' : 'text-slate-900'}`} data-id="element-280">
          {premium ? '$27.990' : '$19.990'}
        </p>
      </div>

      <Button href={premium ? purchaseUrls.complete : purchaseUrls.stretching} fullWidth className={premium ? 'bg-gold text-xs text-slate-900 shadow-gold/30 hover:bg-[#ddb248]' : 'text-xs'} data-id="element-281">
        {premium ? 'QUIERO COMBO COMPLETO + ADULTOS MAYORES' : 'QUIERO EL SISTEMA COMBO COMPLETO STRETCHING'}
      </Button>
    </article>;
}
export function Pricing() {
  return <section id="pricing" className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-282">
      <div className="text-center" data-id="element-283">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-teal md:text-sm" data-id="element-284">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-285">
          Asegurá el precio promocional{' '}
          <span className="text-teal" data-id="element-286">antes de que suba.</span>
        </h2>
        <div className="mt-6" data-id="element-287">
          <Countdown data-id="element-288" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-289">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve', '72% de los cupos ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-290">
              <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-291" />
              {item}
            </span>)}
        </div>
      </div>

      <h2 className="mt-14 text-center text-3xl font-extrabold text-slate-900 md:text-5xl" data-id="element-292">
        Elegí tu <span className="text-teal" data-id="element-293">opción</span>
      </h2>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-294">
        <PlanCard data-id="element-295" />
        <PlanCard premium data-id="element-296" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-slate-500" data-id="element-297">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}
export function Upsell() {
  const rows = [['Alumno 60+ que se anota', 'No sabés qué darle', 'Protocolo exacto disponible'], ['Alumno con prótesis de cadera', 'No podés avanzar', 'Restricciones específicas listas'], ['Alumno con osteoporosis', 'Lo mandás al médico y no vuelve', 'Test funcional + programa adaptado'], ['Alumno con artrosis', '“Esperá que consulto”', 'Semáforo médico listo'], ['Ingresos por alumno', '3-4 meses promedio', '12-18 meses por alumno'], ['Diferenciación de mercado', 'Igual que todos', 'Único especializado en tu zona']];
  return <section className="border-y border-sky-100 bg-sky-50/70 px-4 py-16 md:py-24" data-id="element-298">
      <div className="mx-auto max-w-5xl" data-id="element-299">
        <p className="mb-3 text-center text-[11px] font-bold uppercase tracking-[.16em] text-gold md:text-sm" data-id="element-300">
          <CrownIcon className="mr-1 inline h-4 w-4" data-id="element-301" /> Upgrade premium
        </p>
        <h2 className="mx-auto max-w-3xl text-center text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-302">
          ¿Qué agrega el{' '}
          <span className="text-teal" data-id="element-303">Stretching Adultos Mayores?</span>
        </h2>

        <div className="mt-10 rounded-3xl border border-teal/25 bg-white p-3 shadow-lg shadow-teal/10 sm:p-6 md:p-10" data-id="element-304">
          <div className="grid grid-cols-3 gap-2 border-b border-sky-100 pb-4 text-[10px] font-bold uppercase tracking-wide text-slate-500 sm:text-sm" data-id="element-305">
            <span data-id="element-306">Situación</span>
            <span className="text-red-500" data-id="element-307">Sin Adultos Mayores</span>
            <span className="text-teal" data-id="element-308">Con Adultos Mayores</span>
          </div>
          {rows.map(([situation, without, withValue]) => <div key={situation} className="grid grid-cols-3 gap-2 border-b border-sky-50 py-3 last:border-0" data-id="element-309">
              <b className="text-[11px] leading-tight text-slate-900 sm:text-sm" data-id="element-310">
                {situation}
              </b>
              <span className="text-[11px] leading-tight text-slate-500 sm:text-sm" data-id="element-311">
                {without}
              </span>
              <b className="rounded-lg bg-teal/10 px-1.5 py-1 text-[11px] leading-tight text-teal sm:px-3 sm:text-sm" data-id="element-312">
                {withValue}
              </b>
            </div>)}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center font-medium leading-relaxed text-slate-700" data-id="element-313">
          Si además de resolver tus clases querés{' '}
          <b className="text-teal" data-id="element-314">
            acceder al nicho más rentable del mercado,
          </b>{' '}
          esta es tu opción.
        </p>
      </div>
    </section>;
}
export function FinalCTA() {
  return <section className="relative overflow-hidden px-4 py-16 md:py-24" data-id="element-315">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-teal/10 blur-[130px]" data-id="element-316" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-317">
        <h2 className="text-3xl font-extrabold leading-tight text-slate-900 md:text-5xl" data-id="element-318">
          Tus clases de stretching,{' '}
          <span className="text-teal" data-id="element-319">listas desde hoy.</span>
        </h2>
        <p className="mt-4 text-lg font-medium text-slate-600" data-id="element-320">
          Sin buscar. Sin armar. Sin improvisar.
        </p>
        <p className="mt-8 text-sm font-bold uppercase tracking-wide text-slate-500" data-id="element-321">
          ⏰ El precio cierra en:
        </p>
        <div className="mt-4" data-id="element-322">
          <Countdown data-id="element-323" />
        </div>
        <div className="mx-auto mt-12 grid max-w-5xl gap-7 md:grid-cols-2" data-id="element-324">
          <PlanCard compact data-id="element-325" />
          <PlanCard compact premium data-id="element-326" />
        </div>
        <div className="mt-9 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-500" data-id="element-327">
          <span className="flex gap-1" data-id="element-328">
            <LockIcon className="h-4 w-4 text-teal" data-id="element-329" /> Pago 100% seguro
          </span>
          <span className="flex gap-1" data-id="element-330">
            <ZapIcon className="h-4 w-4 text-teal" data-id="element-331" /> Acceso en 5 minutos
          </span>
          <span className="flex gap-1" data-id="element-332">
            <ShieldCheckIcon className="h-4 w-4 text-teal" data-id="element-333" /> Garantía de 7 días
          </span>
        </div>
      </div>
    </section>;
}